/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type InventoryItem = {
    id?: string;
    /**
     * Original item ID
     */
    itemId?: string;
    /**
     * Owner user ID
     */
    userId?: string;
    /**
     * Item name
     */
    name?: string;
    /**
     * Item image URL
     */
    image?: string;
    /**
     * Item price in cents
     */
    price?: number;
    /**
     * Item status: 0=Available, 1=Pending, 2=Sold, 3=Withdrawn, 4=Locked
     */
    status?: InventoryItem.status;
    /**
     * Whether item is tradeable
     */
    tradeable?: boolean;
    /**
     * Whether item is marketable
     */
    marketable?: boolean;
    createdAt?: string;
    updatedAt?: string;
};
export namespace InventoryItem {
    /**
     * Item status: 0=Available, 1=Pending, 2=Sold, 3=Withdrawn, 4=Locked
     */
    export enum status {
        '_0' = 0,
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
    }
}

